import React, {Component} from 'react'
import {Card, CardBody, CardTitle, Button} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from "react-toastify"
import {withRouter} from 'react-router-dom'

import mutation from '../../../queries/server/mutations/change_user_password'

class FirstLoginChangePassword extends Component{

    state = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    }

    render(){

        return(
            <div className="container-fluid flex-fullheight">
                <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center pt-4">
                    <Card className="shadow-sm p-3 mb-5 bg-white rounded login-card">
                        <CardTitle>Update Password</CardTitle>
                        <div className="d-flex align-items-center justify-content-center">
                            <Mutation mutation={mutation}>
                                {(mutationFunc, {loading}) => (
                                    <AvForm
                                        className="d-flex flex-column"
                                        style={{flex: 1}}
                                        onValidSubmit={() => {

                                            const user = JSON.parse(sessionStorage.getItem('user'))

                                            mutationFunc({variables: {...this.state, user_id: user.user.user_id}})
                                                .then(() => {
                                                    toast.success('Password Successfully Updated', {autoClose: 2000})
                                                    this.props.history.replace('/dashboard')
                                                    this.setState({newPassword: '', confirmPassword: ''})
                                                })
                                                .catch(e => {
                                                    toast.error(e.message, {autoClose: false})
                                                })
                                        }}
                                    >
                                        <AvField
                                            required
                                            type="password"
                                            name="existingPassword"
                                            label="Current Password*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({currentPassword: evt.target.value})}
                                        />

                                        <AvField
                                            required
                                            type="password"
                                            name="password"
                                            label="New Password*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({newPassword: evt.target.value})}
                                        />

                                        <AvField
                                            required
                                            type="password"
                                            name="confirmPassword"
                                            label="Confirm Password*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({confirmPassword: evt.target.value})}
                                        />

                                        <div className="d-flex flex-row justify-content-end">
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={loading}
                                            >
                                                {loading ? 'Updating Password...' : 'Reset Password'}{' '}
                                                {loading && <FontAwesomeIcon
                                                    color="#fff"
                                                    icon="spinner"
                                                    spin
                                                />}
                                            </Button>
                                        </div>
                                    </AvForm>
                                )}

                            </Mutation>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }

}

FirstLoginChangePassword = withRouter(FirstLoginChangePassword)

export default FirstLoginChangePassword